import React from 'react'
import { Link } from 'react-router-dom'
import { changeFormatdateSlip } from '../../../../utils/formatdate'
import { Typography, Tabs, Row, Col, Form, Input, Switch, DatePicker, Pagination, Icon, Button, Modal, Checkbox, Select, Spin } from 'antd'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import { UrlMeeting } from '../../../../utils/auth'
import { downloadFile } from '../../../../utils/downloadFile'
import axios from 'axios';
import moment from 'moment/min/moment-with-locales';
import iconDeclineRed from '../../../../assets/images/icons/icon-decline-red.png'
import iconInfoYellow from '../../../../assets/images/icons/icon-info-yellow.png'
import iconSummitGreen from '../../../../assets/images/icons/icon-summit-green.png'
import iconSwap from '../../../../assets/images/icons/icon-swap.png'
import axiosAPI from '../../../../config/axiosAPI'


const { Option } = Select;
const { Search, TextArea } = Input;
const { TabPane } = Tabs;
const { Text, Title } = Typography
const STATE = {
    ADD_DELEGATE_USER: 1,
    ADD_DELEGATE_NOTE: 2,
}

class InviteMeetingForm extends React.Component {

    
    
    state = {
        idMeeting: null,
        statusAccept: "",
        fromPage: "/meetingmanagement/inviteMeeting",
        needApprove: "no",
        dataMeeting: [],
        GuestsInvite: [],
        OtherGuestsInvite: [],
        ApproverDetail: [],
        OrganizerDetail: [],
        showModalAcceptInvite: false,
        textModalSuccess: '',
        showModalSuccess: false,
        showModalCancleInvite: false,
        textModalCancle: '',
        showModalCancle: false,
        showModalChangeUser: false,
        showModalConfirmChangeUser: false,
        preload: true,
        openMorefile: false,
        listInviteInternal: [],
        id: "",
        type: "",
        showModal: false,
        showModalSuccessAccept: false,
        groupCode: "",
        orgCode: "",
        inviteInternal: [],
        limitpaginateGuset: 10,
        totalpaginateGuset: 0,
        currentPaginateGuset: 1,
        showlistInviteExternal: [],
        countshowlistInviteExternal: 0,
        dropdownGroup: [],
        dropdownOrg: [],
        dropdownDivision: [],
        dropdownDepartment: [],
        searchNameInternal: "",
        lastEditDate: "",
        loadingInternal: false,
        valueSelectOrg: "",
        valueSelectDep: "",
        valueSelectDiv: "",
        isDelegate: false,
        delegateDetail: null,
        isCheckBox: "",
        isSearch: false,
        loadingScreen: false,
        showModalInvitee: false,
        note: "",
        currentAddDelegateState: STATE.ADD_DELEGATE_USER
    }


    componentDidMount = async () => {
        this.fetchDataMeeting();
        this.fetchListOrg();
        this.fetchListGroup();
    }
    fetchDataMeeting = async () => {
        this.setState({ loadingScreen: true });
        const queryString = require('query-string');
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.id) await this.setState({ idMeeting: parsed.id })
        if (parsed.from) await this.setState({ fromPage: parsed.from })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/meetingdetail`,
            {
                MeetingID: parsed.id
            })
            .then(response => {
                const data = response.data.status.message
                this.setState({
                    dataMeeting: data[0] ? data[0] : [],
                    ApproverDetail: data[1].ApproverDetail ? data[1].ApproverDetail : [],
                    OrganizerDetail: data[1].OrganizerDetail ? data[1].OrganizerDetail : [],
                    GuestsInvite: data[0].Guests ? data[0].Guests : [],
                    OtherGuestsInvite: data[0].OtherGuests ? data[0].OtherGuests : [],
                    lastEditDate: moment(data[0]?.updateDate).add(543, 'year').locale('th').format('DD MMMM YYYY HH:mm น.') || "",
                    preload: false,
                    loadingScreen: false,
                })
                console.log("data[0].Guests", data[0].Guests);
                // this.getFileBase64WithID(data[0].Attacheds[0].id);
                const found = (data[0].Guests).find(obj => {
                    return obj.userID === sessionStorage.getItem('username');
                });

                if (data[0].Guests && found.StatusResponse.statusName) {
                    this.setState({ statusAccept: found.StatusResponse.statusName });
                }

                const checkDelegate = (found?.Delegate !== null || found?.isDelegate)
                this.setState({ isDelegate: checkDelegate });

                if (found?.Delegate !== null) {
                    const findDelegate = data[0].Guests.find(o => o.userID == found.Delegate.userID)
                    this.setState({ delegateDetail: findDelegate });
                }
            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })
    }

    fetchListUser = (groupCode, orgcode, limit, offset, input) => {
        this.setState({ loadingInternal: true })
        axiosAPI.get(`${UrlMeeting()}/meeting/secure/finduserlistbyorg?groupId=${groupCode}&orgcode=${orgcode}&limit=${limit}&offset=${offset}&input=${input}`)
            .then(response => {
                const data = response.data.status.message.fetchListEmployeeForTwoWayByCondition
                this.setState({
                    inviteInternal: data.data,
                    totalpaginateGuset: data.total - 10,
                    loadingInternal: false,
                    isSearch: true,
                })
            }).catch(error => {
                this.setState({
                    loadingInternal: false,
                    isSearch: true,
                })
                console.error(`Error: ${error}`)
            })
    }
    fetchListGroup = () => {
        axiosAPI.get(`${UrlMeeting()}/meeting/secure/group/listgroupmeetingall`)
            .then(response => {
                const data = response.data
                // console.log("fetchListGroup", data);
                this.setState({
                    dropdownGroup: data
                })

            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    fetchListOrg = () => {
        axiosAPI.get(`${UrlMeeting()}/meeting/secure/finddropdownbyorg/org/`)
            .then(response => {
                const data = response.data.status.message.fetchListOrgForTwoway
                // console.log("dropdownOrg", data);
                this.setState({
                    dropdownOrg: data
                })

            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    fetchListDiv = (id) => {
        axiosAPI.get(`${UrlMeeting()}/meeting/secure/finddropdownbyorg/division/?id=${id}`)
            .then(response => {
                const data = response.data.status.message.fetchListDivisionForTwoway
                this.setState({
                    dropdownDivision: data
                })

            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    fetchListDep = (id) => {
        axiosAPI.get(`${UrlMeeting()}/meeting/secure/finddropdownbyorg/department/?id=${id}`)
            .then(response => {
                const data = response.data.status.message.fetchListDepartmentForTwoway
                // console.log("dropdownDepartment", data);
                this.setState({
                    dropdownDepartment: data
                })

            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    ChangeTextSearch = (value) => {
        // console.log("value",value.target.value);
        this.setState({
            searchNameInternal: value.target.value
        })
    }
    ChangeGroup = (value) => {
        // console.log("value",value);
        if (value) {
            this.setState({
                groupCode: value,
            })
        } else {
            this.setState({
                groupCode: "",
            })
        }
    }
    ChangeOrg = (value) => {

        if (value) {
            this.setState({
                orgCode: value,
                valueSelectOrg: value,
                valueSelectDiv: "",
                valueSelectDep: "",
                dropdownDivision: [],
                dropdownDepartment: [],
                disableGroup: true
            })

            this.fetchListDiv(value);

        } else {
            this.setState({
                orgCode: "",
                valueSelectOrg: "",
                valueSelectDiv: "",
                valueSelectDep: "",
                dropdownDivision: [],
                dropdownDepartment: [],
                disableGroup: false
            })
        }
    }
    ChangeDiv = (value) => {

        if (value) {
            this.setState({
                orgCode: value,
                valueSelectDiv: value,
                valueSelectDep: "",
                dropdownDepartment: [],
                disableGroup: true
            })

            this.fetchListDep(value);

        } else {
            this.setState({
                orgCode: "",
                valueSelectDiv: "",
                valueSelectDep: "",
                dropdownDepartment: [],
                disableGroup: false
            })
        }
    }
    ChangeDep = (value) => {

        if (value) {
            this.setState({
                orgCode: value,
                valueSelectDep: value,
                disableGroup: true
            })

        } else {
            this.setState({
                orgCode: "",
                valueSelectDep: "",
                disableGroup: false
            })
        }
    }
    onChangePage = page => {
        this.setState({
            currentPaginateGuset: page,
        });
        this.fetchListUser(this.state.groupCode ,this.state.orgCode, this.state.limitpaginateGuset, page * this.state.limitpaginateGuset, this.state.searchNameInternal);
    };

    confirmSearch = () => {
        const orgCode = this.state.valueSelectDep ? this.state.valueSelectDep :
            this.state.valueSelectDiv ? this.state.valueSelectDiv :
                this.state.valueSelectOrg

        this.fetchListUser(this.state.groupCode, orgCode, this.state.limitpaginateGuset, 0, this.state.searchNameInternal);

    };
    getFileBase64WithID = ($id) => {
        axiosAPI.get(`${UrlMeeting()}/meeting/secure/attacment/` + $id)
            .then(response => {
                // console.log("response.data.status.message.fileData",response.data.status.message.fileData);
                window.open(response.data.status.message.fileData, '_blank')
                // return response.data.status.message.fileData;

            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    handleCancel = () => {
        this.setState({
            showModalAcceptInvite: false,
            showModalCancelInvite: false,
            showModalChangeUser: false,
            openMorefile: false,
            showModal: false,
            dropdownDivision: [],
            dropdownDepartment: [],
            searchNameInternal: "",
            loadingInternal: false,
            valueSelectOrg: "",
            valueSelectDep: "",
            valueSelectDiv: "",
            inviteInternal: [],
            showlistInviteExternal: [],
            isSearch: false,
            note: "",
            currentAddDelegateState: STATE.ADD_DELEGATE_USER
        })
    }
    handleOpen = () => {
        this.setState({
            showModalAcceptInvite: true
        })
    }
    handleOkSaveAcceptInviteSuccess = () => {
        this.setState({
            textModalSuccess: 'เข้าร่วมการประชุมสำเร็จ',
            showModalAcceptInvite: false,
            showModalSuccess: true,
        })
        setTimeout(() => {
            this.setState({
                showModalSuccess: false
            })
        }, 1000);
    }

    handleCancleMeeting = () => {
        this.setState({
            showModalCancelInvite: true
        })
    }
    handleOkCancelInviteSuccess = () => {
        this.setState({
            textModalDelete: 'ปฏิเสธการประชุม',
            showModalCancelInvite: false,
            showModalConfirmDelete: true,
        })
        setTimeout(() => {
            this.setState({
                showModalConfirmDelete: false
            })
        }, 1000);
    }

    handleChangeUser = () => {
        this.setState({
            showModalChangeUser: true
        })
    }
    handleOkSaveChangeUser = () => {
        this.setState({
            textModalSuccess: 'ส่งตัวแทนเข้าร่วมการประชุมสำเร็จ',
            showModalChangeUser: false,
            showModalConfirmChangeUser: true,
        })
        setTimeout(() => {
            this.setState({
                showModalConfirmChangeUser: false
            })
        }, 1000);
    }
    getLength = (arr) => {
        if (arr) {
            return arr.length;
        }
    }
    openListFile = () => {
        this.setState({ openMorefile: !this.state.openMorefile })
    }
    clickAccept = (id, type) => {
        this.setState({ loadingScreen: true });
        if (type == "JOIN") {
            axiosAPI.post(`${UrlMeeting()}/meeting/secure/acceptanceMeeting`,
                {
                    UserID: sessionStorage.getItem('username'),
                    MeetingID: id,
                    Status: "JOIN",
                    Delegate: {
                    }
                })
                .then(response => {
                    this.setState({ loadingScreen: false });
                    this.fetchDataMeeting();
                }).catch(error => {
                    this.setState({ loadingScreen: false, })
                    console.error(`Error: ${error}`)
                })
        }
        else if (type == "REFUSE") {
            axiosAPI.post(`${UrlMeeting()}/meeting/secure/acceptanceMeeting`,
                {
                    UserID: sessionStorage.getItem('username'),
                    MeetingID: id,
                    Status: "REJECT",
                    Delegate: {
                    }
                })
                .then(response => {
                    this.setState({ loadingScreen: false });
                    this.fetchDataMeeting();
                }).catch(error => {
                    this.setState({ loadingScreen: false, })
                    console.error(`Error: ${error}`)
                })
        }
        else {
            axiosAPI.post(`${UrlMeeting()}/meeting/secure/acceptanceMeeting`, {
                UserID: sessionStorage.getItem('username'),
                MeetingID: id,
                Status: "DELEGATE",
                Delegate: type,
                note: this.state.note
            })
            .then(() => {
                this.setState({ loadingScreen: false });
                this.fetchDataMeeting();
            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })
        }
    }

    clickChange = async (id, type) => {
        await this.setState({
            id,
            type,
            showModal: true
        })
        console.log("id , type", this.state.id, this.state.type);
    }
    handleOk = () => {
        this.clickAccept(this.state.id, this.state.type);
        this.setState({
            showModal: false,
            showModalSuccessAccept: true
        })
        setTimeout(() => {
            this.setState({
                showModalSuccessAccept: false
            })
        }, 1000);
    }

    handleChangeUser = async (id, type) => {
        await this.setState({
            id,
            type,
            showModalChangeUser: true
        })
        // console.log("id , type", this.state.id, this.state.type);
    }

    handleNextAddAttendeeInternal = async () => {
        this.setState({
            currentAddDelegateState: STATE.ADD_DELEGATE_NOTE
        })
    }

    handleBackAddAttendeeInternal = async () => {
        this.setState({
            currentAddDelegateState: STATE.ADD_DELEGATE_USER
        })
    }

    handleOkSaveInternal = async () => {

        this.clickAccept(this.state.id, this.state.showlistInviteExternal);
        this.handleCancel();
        this.setState({
            showModalChangeUser: false,
            showModalSuccessAccept: true
        })
        setTimeout(() => {
            this.setState({
                showModalSuccessAccept: false
            })
        }, 1000);
    }
    onCheckAddInternal = async (e) => {
        if (e.target.checked) {
            const findDelegate = this.state.GuestsInvite.some(o => o.userID == e.target.value)
            if (findDelegate) {
                this.setState({ showlistInviteExternal: [] })
            } else {
                this.setState({
                    showlistInviteExternal: [{ "UserID": e.target.value }],
                })
            }

        } else {
            const newshowlistInviteExternal = this.state.showlistInviteExternal.filter(element => element.UserID != e.target.value);
            this.setState({
                isCheckBox: "",
                showlistInviteExternal: newshowlistInviteExternal
            });
        }
        // console.log("showlistInviteExternal", this.state.showlistInviteExternal);
    }

    getLengthAcceptInternal = (data) => {
        return data.filter(o => o.StatusResponse.statusName.toLowerCase() == "join").length
    }

    getLengthAcceptExternal = (data) => {
        return data.filter(o => o.asRole == "1").length
    }

    onCloseModalInvitee = () => {
        this.setState({ showModalInvitee: false })
    }

    selectIconPath = (status) => {
        switch (status) {
            case 'Waiting':
                return iconInfoYellow
            case 'Join':
                return iconSummitGreen
            case 'Refuse':
                return iconDeclineRed
            case 'Agent':
                return iconSwap
            case '1':
                return iconInfoYellow
            case '2':
                return iconSummitGreen
        }
    }

    handleChangeNote = (event) => {
        this.setState({
            note:  event.target.value
        })
    }

    checkURLLINK = (linkUrl) =>{
      if(linkUrl){
         if (linkUrl.includes("http")) {
            return linkUrl
         }else{
            return "http://"+linkUrl
         }
      }
    }
//     if (!checkDatemore.includes("-")) {
//       return moment(startDate)
//   }

    render() {
        const { match } = this.props
        const { dataMeeting, ApproverDetail, OrganizerDetail, OtherGuestsInvite, GuestsInvite, preload, delegateDetail } = this.state
        const concatDelegateName = (delegateDetail?.title || "") + " " + (delegateDetail?.firstName || "") + " " + (delegateDetail?.lastName || "");
        const delegateFullName = concatDelegateName.trim() === "" ? "" : concatDelegateName
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalConfirmErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Spin tip="Loading..." size="large" spinning={this.state.loadingScreen} style={{ alignItems: 'center', position: 'initial' }}>
                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.showModal}
                        onCancel={this.handleCancel}
                        footer={[
                            <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                                ยกเลิก</Button>,
                            <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOk}>
                                ยืนยัน</Button>,
                        ]}
                        closable={false}
                    >
                        <div align="center">
                            {
                                this.state.type == "JOIN" ?
                                    <p style={{ fontSize: "20px" }}>
                                        คุณตอบรับการเข้าร่วมประชุม<br />
                                        ใช่หรือไม่
                                    </p>
                                    :
                                    <p style={{ fontSize: "20px" }}>
                                        คุณปฏิเสธการเข้าร่วมประชุม<br />
                                        ใช่หรือไม่
                                    </p>
                            }
                        </div>
                    </Modal>
                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.showModalSuccessAccept}
                        onCancel={this.handleCancel}
                        footer={null}
                        closable={false}
                    >
                        {this.state.type == "JOIN" ?
                            <div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
                                <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
                                <p style={{ fontSize: "20px" }}>
                                    เข้าร่วมการประชุมสำเร็จ
                                </p>
                            </div>
                            :
                            <>
                                {this.state.type == "REFUSE" ?
                                    <div className={'py-5'} style={{ textAlign: 'center', color: "#d7222a" }}>
                                        <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="close-circle" />
                                        <p style={{ fontSize: "20px" }}>
                                            ปฏิเสธการประชุม
                                        </p>
                                    </div>
                                    :
                                    <div className={'py-5'} style={{ textAlign: 'center', color: "##666666" }}>
                                        <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="swap" />
                                        <p style={{ fontSize: "20px" }}>
                                            ส่งตัวแทนเข้าร่วมการประชุมสำเร็จ
                                        </p>
                                    </div>
                                }
                            </>
                        }
                    </Modal>

                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.showModalSuccess}
                        onCancel={this.handleCancel}
                        footer={null}
                        closable={false}
                    >
                        <div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
                            <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
                            <p style={{ fontSize: "20px" }}>
                                {this.state.textModalSuccess}
                            </p>
                        </div>
                    </Modal>
                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.showModalAcceptInvite}
                        onCancel={this.handleCancel}
                        footer={[
                            <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                                ยกเลิก</Button>,
                            <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOkSaveAcceptInviteSuccess}>
                                ยืนยัน</Button>,
                        ]}
                        closable={false}
                    >
                        <div align="center">
                            <p style={{ fontSize: "20px" }}>
                                คุณตอบรับการเข้าร่วมประชุม<br />
                                ใช่หรือไม่
                            </p>
                        </div>
                    </Modal>

                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.showModalConfirmDelete}
                        onCancel={this.handleCancel}
                        footer={null}
                        closable={false}
                    >
                        <div className={'py-5'} style={{ textAlign: 'center', color: "#d7222a" }}>
                            <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="close-circle" />
                            <p style={{ fontSize: "20px" }}>
                                {this.state.textModalDelete}
                            </p>
                        </div>
                    </Modal>

                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.showModalCancelInvite}
                        onCancel={this.handleCancel}
                        footer={[
                            <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                                ยกเลิก</Button>,
                            <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOkCancelInviteSuccess}>
                                ยืนยัน</Button>,
                        ]}
                        closable={false}
                    >
                        <div align="center">
                            <p style={{ fontSize: "20px" }}>
                                คุณปฏิเสธการเข้าร่วมประชุม
                                ใช่หรือไม่<br />
                            </p>
                        </div>
                    </Modal>

                    <Modal
                        destroyOnClose={true}
                        maskClosable={false}
                        className={'list-invite-internal-modal'}
                        visible={this.state.showModalChangeUser}
                        onCancel={this.handleCancel}
                        footer={
                            this.state.currentAddDelegateState === STATE.ADD_DELEGATE_USER ?
                            [
                                <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>ยกเลิก</Button>,
                                <Button key="next" className={'btn-modal-confirm'} disabled={this.state.showlistInviteExternal.length === 0} onClick={this.handleNextAddAttendeeInternal}>ถัดไป</Button>
                            ] :
                            [
                                <Button key="back" className={'btn-modal-cancle'} onClick={this.handleBackAddAttendeeInternal}>ย้อนกลับ</Button>,
                                <Button key="submit" className={'btn-modal-confirm'} disabled={this.state.showlistInviteExternal.length === 0 || this.state.note === ""} onClick={this.handleOkSaveInternal}>ยืนยัน</Button>,
                            ]
                        }
                    >
                    {this.state.currentAddDelegateState === STATE.ADD_DELEGATE_USER ?
                        <Row gutter={16}>
                            <Spin tip="Loading..." size="large" spinning={this.state.loadingInternal} style={{ alignItems: 'center', position: 'initial' }}>
                                <Col xs={24} className={'pb-3'}>
                                    <h1 className="mb-3">เพิ่มผู้เข้าร่วมภายใน</h1>
                                    <Input placeholder="ค้นหา" onChange={value => this.ChangeTextSearch(value)} />
                                </Col>
                                <Col className="mb-1" xs={24}>
                                    <h2 className="mb-1">กลุ่ม</h2>
                                    <Select
                                        defaultValue=""
                                        style={{ width: '100%' }}
                                        onChange={this.ChangeGroup}>
                                        <Option value=""><p style={{ color: "#d9d9d9" }}>กรุณาเลือกกลุ่ม</p></Option>
                                        {
                                            (this.state.dropdownGroup).map(item => (
                                                <Option value={item.id}>{item.groupName}</Option>
                                            ))
                                        }
                                    </Select>
                                </Col>
                                <Col className="mb-1" xs={24}>
                                    <h2 className="mb-1">สำนัก</h2>
                                    <Select defaultValue="" style={{ width: '100%' }} onChange={this.ChangeOrg}>
                                        <Option value=""><p style={{ color: "#d9d9d9" }}>กรุณาเลือกสำนัก</p></Option>
                                        {
                                            (this.state.dropdownOrg).map(item => (
                                                <Option value={item.orgCode}>{item.orgName}</Option>
                                            ))
                                        }

                                    </Select>
                                </Col>
                                <Col className="mb-1" xs={24}>
                                    <h2 className="mb-1">หน่วยงาน</h2>
                                    <Select disabled={!this.state.dropdownDivision.length > 0} defaultValue="" value={this.state.valueSelectDiv} style={{ width: '100%' }} onChange={this.ChangeDiv}>
                                        <Option value=""><p style={{ color: "#d9d9d9" }}>กรุณาเลือกฝ่าย</p></Option>
                                        {
                                            (this.state.dropdownDivision).map(item => (
                                                <Option value={item.divisionCode}>{item.divisionName}</Option>
                                            ))
                                        }
                                    </Select>
                                </Col>
                                <Col className="mb-1" xs={24}>
                                    <h2 className="mb-1">แผนก</h2>
                                    <Select disabled={!this.state.dropdownDepartment.length > 0} defaultValue="" value={this.state.valueSelectDep} style={{ width: '100%' }} onChange={this.ChangeDep}>
                                        <Option value=""><p style={{ color: "#d9d9d9" }}>กรุณาเลือกแผนก</p></Option>
                                        {
                                            (this.state.dropdownDepartment).map((item) => (
                                                <Option key={item.departmentCode} value={item.departmentCode}>{item.departmentName}</Option>
                                            ))
                                        }
                                    </Select>
                                </Col>
                                <Col className="mt-3" xs={24}>
                                    <Button key="submit"
                                        disabled={!this.state.groupCode && !this.state.valueSelectOrg}
                                        // style={{backgroundColor: 'transparent !important'  }}
                                        className={'btn-modal-confirm w-100 mb-2'}
                                        onClick={this.confirmSearch}>
                                        ค้นหา
                                    </Button>
                                </Col>
                                
                                {this.state.inviteInternal.length > 0 ? (
                                    <div>
                                        {this.state.inviteInternal.map((user, i) => {
                                            return (
                                                <Col key={user.userID} xs={24} className={'py-1'}>
                                                    <Checkbox checked={this.state.isCheckBox == user.userID} onClick={() => { this.setState({ isCheckBox: user.userID }) }} onChange={(e) => this.onCheckAddInternal(e, user)}
                                                        name={user.title + " " + user.firstName + " " + user.lastName} value={user.userID}>
                                                        <p style={{ fontSize: "14px", display: "inline" }}>{user.title} {user.firstName} {user.lastName} {user.positionName ? `- ${user.positionName}` : user.positionName} {user.divisionName ? `- ${user.divisionName}` : user.divisionName}</p>
                                                    </Checkbox>
                                                </Col>
                                            )
                                        })}
                                        {this.state.totalpaginateGuset != 0 ?
                                            <Pagination onChange={this.onChangePage} defaultCurrent={this.state.currentPaginateGuset} total={this.state.totalpaginateGuset} />
                                            :
                                            <></>
                                        }
                                    </div>)
                                    : this.state.isSearch ?
                                        <Col xs={24} md={24} align={"center"}>
                                            <Text>ไม่พบข้อมูลรายการ</Text>
                                        </Col>
                                        : <></>
                                }

                            </Spin>
                        </Row> :

                        <Row gutter={16}>
                            <Spin tip="Loading..." size="large" spinning={this.state.loadingInternal} style={{ alignItems: 'center', position: 'initial' }}>
                                <Col className='mb-2' xs={24}>
                                    <h2>เหตุผลในการส่งตัวแทน</h2>
                                    <TextArea rows={4} value={this.state.note} onChange={this.handleChangeNote}></TextArea>
                                </Col>
                            </Spin>
                        </Row>
                    }
                    </Modal>

                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.showModalConfirmChangeUser}
                        onCancel={this.handleCancel}
                        footer={null}
                        closable={false}
                    >
                        <div className={'py-5'} style={{ textAlign: 'center', color: "#666666" }}>
                            <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="swap" />
                            <p style={{ fontSize: "20px" }}>
                                ส่งตัวแทนเข้าร่วมการประชุมสำเร็จ
                            </p>
                        </div>
                    </Modal>


                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.openMorefile}
                        onCancel={this.handleCancel}
                        footer={null}
                        closable={false}
                    >
                        <div className={'py-5'} style={{ textAlign: 'center', color: "#666666" }}>
                            {
                                (dataMeeting.Attacheds ? dataMeeting.Attacheds : []).map((element, i) => {
                                    return (
                                        <a className="text-detail-meeting ml-2"> {element.fileName}<br /></a>
                                    )
                                })}
                        </div>
                    </Modal>
                    <div className="card-container meeting-management" id="form-meeting">
                        <div className="card-bg-white">
                            <Row className="pt-4 pb-3 px-3" gutter={16} type="flex">
                                <Col xs={19} >
                                    {/* <Link
                                    to={{
                                        pathname: this.state.fromPage,
                                    }}>
                                    <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> รายละเอียดการประชุม</p>
                                </Link> */}
                                    <a href="javascript:history.back()">
                                        <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> รายละเอียดการประชุม</p>
                                    </a>
                                </Col>
                                <Col xs={5} align={"right"} >
                                    {dataMeeting.isActive == 2 ?
                                        <Link
                                            to={{
                                                pathname: `/meetingmanagement/createMeetingForm/`,
                                                search: 'approve=' + (dataMeeting.requireApprove ? "yes" : "no")
                                                    + '&note=' + (dataMeeting.requireMeetingSummary ? "yes" : "no")
                                                    + '&id=' + this.state.idMeeting
                                                    + '&from=/meetingmanagement/CreateMeeting'
                                                    + '&status=draft',
                                            }}>
                                            <Icon type="form" style={{ fontSize: "20px", color: "#666666" }} />
                                        </Link>
                                        :
                                        <></>
                                    }
                                </Col>
                            </Row>
                            {
                                preload &&
                                <div className="pt-4 mt-3" style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                    <Icon type="loading" />
                                </div>
                                ||
                                <Row gutter={16} type="flex">
                                    <Col lg={{ span: 20, offset: 2 }} >
                                        <Row className="px-5 py-3 pb-5" gutter={16} type="flex" align="top">
                                            {/* <Col xs={24}>
                                            <p className="text-header-meeting">ส่งบันทึกหลังการประชุม</p>
                                        </Col> */}
                                            {/* <Icon type="user" className="icon-fonttext-meeting" /> */}
                                            <Col xs={12}>
                                                <Icon type="user" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ผู้เชิญประชุม</p><br />
                                                <p className="text-detail-meeting ml-2">{OrganizerDetail.title} {OrganizerDetail.firstName} {OrganizerDetail.lastName}</p>
                                            </Col>
                                            {/* <Icon type="user" className="icon-fonttext-meeting" /> */}
                                            {ApproverDetail.length != 0 ?
                                                < Col xs={12}>
                                                    <Icon type="user" className="icon-fonttext-meeting" />
                                                    <p className="text-title-meeting ml-2 mb-0">ผู้อนุมัติการประชุม</p><br />
                                                    {/* <Icon type="user" className="icon-fonttext-meeting-none" /> */}
                                                    <p className="text-detail-meeting ml-2">{ApproverDetail.firstName} {ApproverDetail.lastName}</p>
                                                </Col>
                                                :
                                                <></>
                                            }
                                            <Col xs={24} className="pt-3">
                                                <Icon type="menu" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">หัวข้อการประชุม</p><br />
                                                {/* <Icon type="menu" className="icon-fonttext-meeting-none" /> */}
                                                <p className="text-detail-meeting ml-2">{dataMeeting.subject}</p>
                                            </Col>

                                            <Col xs={12} className="pt-3">
                                                <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">กำหนดการ</p><br />
                                                {/* <Icon type="clock-circle" className="icon-fonttext-meeting-none" /> */}
                                                <p className="text-detail-meeting ml-2">{changeFormatdateSlip(moment(dataMeeting.startDate))} / {moment(dataMeeting.startDate).format('HH:mm')} - {moment(dataMeeting.endDate).format('HH:mm')} น.</p>
                                            </Col>
                                            <Col xs={12} className="pt-3">
                                                <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0" style={{ display: 'inline' }}>วันที่ออกเอกสาร</p><br />
                                                {/* <Icon type="clock-circle" className="icon-fonttext-meeting-none" style={{ display: 'inline' }} /> */}
                                                <p className="text-detail-meeting ml-2" style={{ display: 'inline' }}>{dataMeeting.documentDate ? moment(dataMeeting.documentDate).locale('th').add(543, 'year').format('DD MMMM YYYY') : "-"}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="environment" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">สถานที่จัดการประชุม</p><br />
                                                {/* <Icon type="environment" className="icon-fonttext-meeting-none" /> */}
                                                <p className="text-detail-meeting ml-2">{dataMeeting.location}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="team" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">รายชื่อผู้ถูกเชิญ ({this.getLength(GuestsInvite) + this.getLength(OtherGuestsInvite)})</p>
                                                <span onClick={() => this.setState({ showModalInvitee: true })} style={{ color: '#3C8BE9', cursor: 'pointer' }}>{"  ดูเพิ่มเติม"}</span>
                                                <br />
                                            </Col>

                                            <Col xs={12} className="pt-3">
                                                {/* <Icon type="clock-circle" className="icon-fonttext-meeting-none" /> */}
                                                <p className="text-title-meeting ml-2 pl-3">ผู้เข้าร่วมภายใน ({this.getLengthAcceptInternal(GuestsInvite)}/{this.getLength(GuestsInvite)})</p><br />

                                                {
                                                    GuestsInvite.map((element, i) => {
                                                        if (i >= 5) {
                                                            return <></>
                                                        }
                                                        return (<p className="text-detail-meeting ml-2">{i + 1}. {element.title} {element.firstName} {element.lastName}<br /></p>)
                                                    }
                                                    )
                                                }

                                                {/* <a className="see-more-button">
                                            <p>ดูเพิ่มเติม</p>
                                        </a> */}
                                            </Col>
                                            <Col xs={12} className="pt-3">
                                                {/* <Icon type="clock-circle" className="icon-fonttext-meeting-none" /> */}
                                                <p className="text-title-meeting ml-2 pl-3">ผู้เข้าร่วมภายนอก ({this.getLengthAcceptExternal(OtherGuestsInvite)}/{this.getLength(OtherGuestsInvite)})</p><br />
                                                {
                                                    OtherGuestsInvite.map((element, i) => {
                                                        if (i >= 5) {
                                                            return <></>
                                                        }
                                                        return (<p className="text-detail-meeting ml-2">{i + 1}. {element.name}<br /></p>)
                                                    }
                                                    )
                                                }
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="menu" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">รายละเอียด</p><br />
                                                {/* <Icon type="menu" className="icon-fonttext-meeting-none" /> */}
                                                <p className="text-detail-meeting ml-2">{dataMeeting.detail}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="video-camera" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ลิงค์การประชุม</p><br />
                                                {/* <Icon type="menu" className="icon-fonttext-meeting-none" /> */}
                                                
                                                <a href={this.checkURLLINK(dataMeeting.meetingURL)} target='__blank' className="ml-3">
                                                   {this.checkURLLINK(dataMeeting.meetingURL)}
                                                </a>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="paper-clip" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ไฟล์แนบ</p><br />
                                                {
                                                    (
                                                        dataMeeting.Attacheds ? dataMeeting.Attacheds : []).map((file, i) =>
                                                            <Row>
                                                                <a className="ml-4" onClick={() => {
                                                                    downloadFile(`${UrlMeeting()}/meeting/file/${file.fileNameGen}`, file.fileName)
                                                                }}>{file.fileName}</a>
                                                            </Row>
                                                        )
                                                }
                                                {/* {
                                             (dataMeeting.Attacheds ? dataMeeting.Attacheds : []).length > 4 ?
                                                <a onClick={this.openListFile} className='ml-5'>ดูทั้งหมด</a>
                                                :
                                                <></>

                                            } */}
                                            </Col>

                                            {delegateDetail && (<Col xs={24} className="pt-3">
                                                <Icon type="swap" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ส่งตัวแทน</p><br />
                                                <p className="text-detail-meeting ml-2">{delegateFullName || ''}</p>
                                            </Col>)}

                                            {delegateDetail && (<Col xs={24} className="pt-3">
                                                <Icon type="menu" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">เหตุผลในการส่งตัวแทน</p><br />
                                                <p className="text-detail-meeting ml-2">{delegateDetail.note || ''}</p>
                                            </Col>)}

                                            <Col xs={24} style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <Col xs={24} xl={12}>
                                                    {this.state.lastEditDate && (
                                                        <Col xs={24} className="mt-5">
                                                            <p className="text-title-meeting mb-0">{"แก้ไขล่าสุด: " + this.state.lastEditDate}</p><br />
                                                        </Col>
                                                    )
                                                    }
                                                </Col>
                                                {dataMeeting.isActive != 2 && (
                                                    <Col xs={24} md={24} xl={12} className={"mt-5"} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                        {this.state.statusAccept == "Waiting" ?
                                                            <Col xs={24} align="end" style={{ display: 'flex', justifyContent: 'center' }}>
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.clickChange(dataMeeting.id, "REFUSE")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
                                                                        ปฏิเสธ</Button>
                                                                </Col>
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.handleChangeUser(dataMeeting.id, "AGENT")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} >
                                                                        ส่งตัวแทน</Button>
                                                                </Col>
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.clickChange(dataMeeting.id, "JOIN")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }}>
                                                                        ตอบรับ</Button>
                                                                </Col>
                                                            </Col>
                                                            :
                                                            <></>
                                                        }
                                                        {this.state.statusAccept == "Join" ?
                                                            <Col xs={24} align="end" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                </Col>
                                                                {!this.state.isDelegate ? <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.handleChangeUser(dataMeeting.id, "AGENT")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} >
                                                                        ส่งตัวแทน</Button>
                                                                </Col>
                                                                    :
                                                                    <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                        <Button disabled={true} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
                                                                            ตอบรับ</Button>
                                                                    </Col>
                                                                }
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.clickChange(dataMeeting.id, "REFUSE")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff", backgroundColor: "#D94339" }}>
                                                                        ปฏิเสธ</Button>
                                                                </Col>
                                                            </Col>
                                                            :
                                                            <></>
                                                        }
                                                        {this.state.statusAccept == "Refuse" ?
                                                            <Col xs={24} align="end" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                </Col>
                                                                {!this.state.isDelegate ? <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.handleChangeUser(dataMeeting.id, "AGENT")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} >
                                                                        ส่งตัวแทน</Button>
                                                                </Col>
                                                                    :
                                                                    <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                        <Button disabled={true} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
                                                                            ปฏิเสธ</Button>
                                                                    </Col>
                                                                }
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.clickChange(dataMeeting.id, "JOIN")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }}>
                                                                        ตอบรับ</Button>
                                                                </Col>
                                                            </Col>
                                                            :
                                                            <></>
                                                        }
                                                        {this.state.statusAccept == "Agent" ?
                                                            <Col xs={24} align="end" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                </Col>
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.clickChange(dataMeeting.id, "REFUSE")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
                                                                        ปฏิเสธ</Button>
                                                                </Col>
                                                                <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                    <Button onClick={e => this.clickChange(dataMeeting.id, "JOIN")} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }}>
                                                                        ตอบรับ</Button>
                                                                </Col>
                                                            </Col>
                                                            :
                                                            <></>
                                                        }
                                                    </Col>
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div >
                    <Modal
                        // maskClosable={false}
                        className={"meeting-invitee-modal"}
                        visible={this.state.showModalInvitee}
                        onCancel={this.onCloseModalInvitee}
                        closable={true}
                        title="รายชื่อผู้อนุมัติการประชุม "
                        footer={[
                            <Button
                                key="close"
                                className={"btn-modal-confirm"}
                                onClick={this.onCloseModalInvitee}
                            >
                                ปิด
                            </Button>
                        ]}
                    >
                        <div style={{ height: 400, width: 400, overflow: "auto", overflowX: "hidden" }}>
                            <Row gutter={16} className={"pt-0"}>
                                <Tabs defaultActiveKey="1" >
                                    <TabPane
                                        style={{ marginLeft: '2%' }}
                                        tab={`ผู้เข้าร่วมภายใน (${this.getLengthAcceptInternal(GuestsInvite)}/${this.getLength(GuestsInvite)})`} key="1">
                                        {GuestsInvite.map((element, i) => {
                                            return (
                                                <Row type='flex' align='middle' className='my-3'>
                                                    <Col xs={20}>
                                                        <span className="text-detail-meeting">{element.title} {element.firstName} {element.lastName}</span>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <img src={this.selectIconPath(element.StatusResponse.statusName)} style={{ maxWidth: '20px', height: 'auto' }} />
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </TabPane>
                                    <TabPane
                                        tab={`ผู้เข้าร่วมภายนอก (${this.getLengthAcceptExternal(OtherGuestsInvite)}/${this.getLength(OtherGuestsInvite)})`} key="2">
                                        {OtherGuestsInvite.map((element, i) => {
                                           console.log("element.asRole", element)
                                            return (
                                                <Row type='flex' align='middle' className='my-3'>
                                                    <Col xs={20}>
                                                        <span className="text-detail-meeting">{element.name}</span>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <img src={this.selectIconPath(element.asRole)} style={{ maxWidth: '20px', height: 'auto' }} />
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </TabPane>
                                </Tabs>
                            </Row>
                        </div>
                    </Modal>
                </Spin>
            </Container >
        )
    }
}

InviteMeetingForm.propTypes = {
    //
}

export default withApollo(InviteMeetingForm)